export const intentDescriptionText =
'The description is used as a part of the prompt for intent recognition. ' +
'It plays a critical role in the successful recognition of the intent.'
